import styled from 'astroturf/react';
import { Link } from 'react-router-dom';

const Footer = styled('footer')`
  padding: 0;
  width: 100%;
  ul{
      padding: 0;
      justify-content: space-between;
      flex-direction: row;
      display: flex;
      margin: 0;  
  }
`;


const link = styled(Link)`  
  font-family: var(--ph-font-family-source-sans-pro);
  font-size: var(--ph-text-xs);
  color: var(--dark-blue);
  border-bottom: 1.5px solid var(--dark-blue);

  &:hover {
    text-decoration: none !important;
    border-color: var(--cyan-green);
    color: var(--dark-blue) !important;
  }
`;

export default { 
    Footer, 
    Link: link 
};
